<div
  class="satellite-style-selector"
  [class.drop-up]="dropDirection === 'up'"
  *ngIf="visible"
  (mouseleave)="onPanelMouseLeave($event)">
  <div class="selector-header">
    <span class="selector-header-title">{{ headerLabel | translate }}</span>
    <button type="button" class="close-btn" (click)="onClose()">
      <i class="pi pi-times"></i>
    </button>
  </div>
  <div class="selector-items">
    @for (style of styles; track style.label) {
      <div class="selector-item-row" (mouseenter)="onItemMouseEnter(style, 0)">
        <div
          class="selector-item"
          [class.selected]="isSelected(style)"
          [class.has-children]="!!style.children?.length"
          (click)="onItemClick(style)">
          <span class="style-label">{{ style.label | translate }}</span>
          @if (style.children?.length) {
            <i class="pi pi-chevron-right item-chevron"></i>
          }
        </div>

        @if (style.children?.length && hoveredItem === style) {
          <div class="selector-submenu" (mouseenter)="onItemMouseEnter(style, 0)">
            @for (child of style.children; track child.label) {
              @let isIndexes = isIndexesMenu(child);
              <div class="selector-item-row selector-item-row--nested" (mouseenter)="onItemMouseEnter(child, 1)">
                <div
                  class="selector-item"
                  [class.selected]="isSelected(child) || (isIndexes && pinnedIndexesPanel)"
                  [class.has-children]="!!child.children?.length"
                  (click)="isIndexes ? onIndexesMenuClick($event, child) : onItemClick(child)">
                  <span class="style-label">{{ child.label | translate }}</span>
                  @if (child.children?.length) {
                    <i
                      class="pi item-chevron"
                      [class.pi-chevron-up]="enableIndexSearch && isIndexes"
                      [class.pi-chevron-right]="!(enableIndexSearch && isIndexes)"></i>
                  }
                </div>

                @if (child.children?.length && isNestedSubmenuVisible(child)) {
                  <div
                    class="selector-submenu selector-submenu--nested"
                    [class.selector-submenu--indexes]="enableIndexSearch && isIndexes"
                    (mouseenter)="onItemMouseEnter(child, 1)"
                    (click)="$event.stopPropagation()">
                    @if (enableIndexSearch && isIndexes) {
                      <div class="selector-search">
                        <i class="pi pi-search selector-search-icon"></i>
                        <input
                          type="text"
                          class="selector-search-input"
                          [(ngModel)]="indexSearchQuery"
                          [placeholder]="'Search' | translate"
                          (click)="$event.stopPropagation()">
                      </div>
                      <div class="selector-index-list">
                        @for (grand of filteredIndexItems; track grand.value) {
                          <div class="selector-item" [class.selected]="isSelected(grand)" (click)="onItemClick(grand)">
                            <span class="style-label">{{ grand.label }}</span>
                          </div>
                        } @empty {
                          <div class="selector-empty">{{ 'NO_DATA_AVAILABLE' | translate }}</div>
                        }
                      </div>
                    } @else {
                      @for (grand of child.children; track grand.label) {
                        <div class="selector-item" [class.selected]="isSelected(grand)" (click)="onItemClick(grand)">
                          <span class="style-label">{{ grand.label | translate }}</span>
                        </div>
                      }
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
